import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import Landing from "@/pages/Landing";
import NewReview from "@/pages/NewReview";
import ReviewResult from "@/pages/ReviewResult";
import Playbooks from "@/pages/Playbooks";
import PlaybookDetail from "@/pages/PlaybookDetail";
import History from "@/pages/History";
import AuthPage from "@/pages/AuthPage";

function App() {
  return (
    <div className="grain min-h-screen flex flex-col">
      <BrowserRouter>
        <AuthProvider>
          <SiteNav />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/new" element={<NewReview />} />
              <Route path="/reviews/:id" element={<ReviewResult />} />
              <Route path="/playbooks" element={<Playbooks />} />
              <Route path="/playbooks/:slug" element={<PlaybookDetail />} />
              <Route path="/history" element={<History />} />
              <Route path="/login" element={<AuthPage mode="login" />} />
              <Route path="/register" element={<AuthPage mode="register" />} />
            </Routes>
          </main>
          <SiteFooter />
          <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, fontFamily: "Public Sans" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
